import { useMutation } from '@tanstack/react-query'
import { planMutationKeys } from '../constants'
import api from '../../config/axios-config'

export const useExportPlanMutation = (options) => {
  const handleMutation = async ({
    filterId,
    includePins,
    pinSize,
    revisionId
  }) => {
    const config = {
      method: 'post',
      data: {
        filterId,
        includePins,
        pinSize,
        revisionId
      }
    }

    const { data } = await api('/api/plans-api/v3/printJobs', config)

    return data
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: [planMutationKeys.EXPORT_PLAN_MUTATION],
    retry: 0,
    ...options,
    onSuccess: (data, variables, context) => {
      return options?.onSuccess?.(data, variables, context)
    },
    onError: (error, variables, context) => {
      return options?.onError?.(error, variables, context)
    }
  })
}
